function openCartDrawer(pCart) {    
    console.log("openCartDrawe", pCart);
    updateAnnouncementBar(pCart);   
    initCartShippingCost(pCart);
}

function updateAnnouncementBar(pCart) {    
    //check for bundle
    var canvasCount = 0;
    for(var i=0; i < pCart.items.length; i++) {           
        if(pCart.items[i].product_type.includes('Leinwand') || pCart.items[i].product_type.includes('Tasse') || pCart.items[i].product_type.includes('Poster') || pCart.items[i].product_type.includes('Malen nach Zahlen')) {           
            canvasCount += pCart.items[i].quantity;
        } 
    }
    //set cart counter   
    $('.cart-link__bubble').text(pCart.items.length);
    
    if(canvasCount == 0) {
        $('.lm-countdown').attr('href', '/');
        $('.lm-countdown div.text').html(" <b>Gute Wahl!</b> Deine Bestellung wird <b>in&nbsp;2‑3&nbsp;Tagen</b> geliefert.");
    } else if(canvasCount == 1) {
        $('.lm-countdown').attr('href', '/checkout');
        //$('.CartAnnouncement__Animation').fadeIn(0).delay(3000).fadeOut(1000);
        $('.lm-countdown div.text').html(" <b>Glückwunsch:</b> Du erhältst zusätzlich dein Motiv als Download im Wert von <b>20€ geschenkt</b> 🎁");
        //$('.lm-cart-item.add-canvas').addClass('active');
    } else if(canvasCount == 2) {
        $('.lm-countdown').attr('href', '/pages/muttertag-vatertag-deal');
        $('.CartAnnouncement__Animation').fadeIn(0).delay(3000).fadeOut(1000);
        $('.lm-countdown div.text').html(" <b>Hurrah!</b> Du erhältst zusätzlich <b>20% Rabatt</b>, da du 2 Leinwände im Warenkorb hast 🎁");
        //$('.lm-cart-item.add-canvas').removeClass('active');
    } else if(canvasCount >= 3) {
        $('.lm-countdown').attr('href', '/checkout');
        $('.CartAnnouncement__Animation').fadeIn(0).delay(3000).fadeOut(1000);
        var text = " <b>Hurrah!</b> Du erhältst zusätzlich <b>20% Rabatt</b>, da du mehr als 2 Leinwände im Warenkorb hast 🎁";
        text = text.replace("[maxleinwandCount]", canvasCount);
        var leinwandCount = Math.floor(canvasCount/3);
        text = text.replace("[leinwandCount]", leinwandCount);
        $('.lm-countdown div.text').html(text);
        //$('.lm-cart-item.add-canvas').removeClass('active');
    }  
}

function initCartShippingCost(pCart) {
    console.log(pCart);
    let itemsCount = 0;
    let hasCanvas = false;
    for(var i=0; i < pCart.items.length; i++) {           
        if(pCart.items[i].product_type.includes('Leinwand')) {
            hasCanvas = true;
        }
        if(['Leinwand', 'Poster', 'Dekoration-Leinwand', 'Trio-Leinwand', 'Tasse', 'Malen nach Zahlen'].includes(pCart.items[i].product_type)) {           
            itemsCount += pCart.items[i].quantity;
        } 
    }

    let FREE_SHIPPING = 2900;
    let PERCENT10 = 4900;
    console.log(pCart.total_price);
    console.log(itemsCount);
    if (itemsCount >= 2) {
        $('.Shipping_Costs__Title .checkmark').fadeIn(0);
        $('.Shipping_Costs__ProgressBar .left').css("width", "100%");
        setTimeout(function() {
            $('.Shipping_Costs__ProgressBar .step2').addClass('completed');
            $('.Shipping_Costs__Animation').fadeIn(0).delay(5000).fadeOut(1000);
        }, 1400);
        setTimeout(function() {
            $('.Shipping_Costs__ProgressBar .step1').addClass('completed');
        }, 700);        
        $('.Shipping_Costs__Text').html("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Hurrah!</b> Du erhältst zusätzlich <b>20% Rabatt</b>, da du 2 Artikel im Warenkorb hast 🎁");
        //$('.Shipping_Costs__ProgressBar img').attr("src", "https://cdn.shopify.com/s/files/1/0288/6965/6658/files/party-1.png?v=1685189119").css("position", "absolute").css("right", "8px");
        
    } else if (pCart.total_price >= FREE_SHIPPING) {
        $('.Shipping_Costs__Title .checkmark').fadeIn(0);
         setTimeout(function() {
            $('.Shipping_Costs__ProgressBar .step1').addClass('completed');
        }, 800);
        $('.Shipping_Costs__ProgressBar .step2').removeClass('completed');
        $('.Shipping_Costs__ProgressBar .left').css("width", "80%");
        if(hasCanvas) {
            $('.Shipping_Costs__Text').html("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Glückwunsch</b>, dein Versand und dein Motiv zum Download im Wert von 20€ sind <b>kostenlos</b>! 🎁"); 
        } else {
            $('.Shipping_Costs__Text').html("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Glückwunsch, dein Versand ist <b>kostenlos</b>. 🎁");            
            $('.Shipping_Costs__Animation').fadeIn(0).delay(5000).fadeOut(1000);
        }
        
    } else {
        $('.Shipping_Costs__Title .checkmark').fadeOut(0);
        $('.Shipping_Costs__ProgressBar .step1').removeClass('completed');
        $('.Shipping_Costs__ProgressBar .step2').removeClass('completed');
        //Make progress
        var remainingPrice = FREE_SHIPPING - pCart.total_price;
        var priceString = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
        $('.Shipping_Costs__Text').html("Nur noch [price] bis zum <b>kostenlosen Versand</b>.".replace('[price]', priceString));
       
        var percentage = 0.5 * ((pCart.total_price / FREE_SHIPPING) * 100).toFixed(2);
        if (percentage >= 85) {
            percentage = 85;
        }
        $('.Shipping_Costs__ProgressBar .left').css("width", percentage + "%");
    }
}

function initProducts() {
    
    //init products
    $(".lm-cart-item.canvas").each(function(key, item) {
        var _this = this;
        var productHandle = $(this).attr("data-product-handle");
        var variantID = parseInt($(this).attr("data-product-variant-id"));

        //load product data        
        $.getJSON("/products/" + productHandle + ".js").then(function(data) {
            //Insert compare_at_price to line item
            var variant = data.variants.find((x) => x.id === variantID);
            var quantity = parseInt($(_this).find(".lm-cart-amount select").val());
            var comparePrice = variant.compare_at_price * quantity;
            var comparePriceString = theme.Currency.formatMoney(
                comparePrice,
                theme.settings.moneyFormat
            );
            $(_this).find(".compare").text(comparePriceString).attr('data-regular-price', comparePrice);

            //Insert saved_amount to line item
            /*let savedPrice = ((comparePrice - variant.price) / comparePrice) * 100;
            console.log(savedPrice);
            if(savedPrice < 100) {
                savedPrice = theme.strings.savePrice.replace(
                    "[saved_amount]",
                    parseInt(savedPrice)
                );
                $(_this).find(".lm-percent").text(savedPrice);
            }*/
            
            const selectedBaseVariant = data.variants.find(item => item.option1 === variant.option1 && item.option2 === "Ohne");   
            if(selectedBaseVariant) {
               const priceDelta = variant.price - selectedBaseVariant.price;
                if(priceDelta > 0) {
                    $(_this).find('.lm-cart-size.frame .price-delta').text('(+ ' + theme.Currency.formatMoney(priceDelta,theme.settings.moneyFormat) + ')');
                }  
            }
            data.variants = data.variants.filter(item => item.option2 === variant.option2);            
            data.variants = data.variants.map(item => ({
                ...item,
                title: item.title.split(" / ")[0]
            }));      

            //Insert variant options for dropdown
            if(data.variants.length == 1) {
              $(_this).find(".lm-cart-size").fadeOut(0);
            }
            
            var html = "";
            for (var i = 0; i < data.variants.length; i++) {
                //Hide 120cm+
                let disabled = "";
                if(variant.option2 != "Ohne" && data.variants[i].option1.includes('160')) {
                  disabled = "disabled";
                }
                var price = data.variants[i].price;
                var priceString = theme.Currency.formatMoney(
                    price,
                    theme.settings.moneyFormat
                );

                //Selected value    
                var selected = "";
                if (data.variants[i].id == variantID) {
                     selected = "selected";
                }
                if (
                    data.variants[i].title.includes("80 x 60 cm") ||
                    data.variants[i].title.includes("60 x 80 cm") ||
                    data.variants[i].title.includes("80 x 55 cm") ||
                    data.variants[i].title.includes("55 x 80 cm")
                ) {
                    var bestseller = " (⭐ Bestseller)";
                } else {
                    var bestseller = "";
                }
                html +=
                    "<option " + disabled + " " +
                    selected +
                    " value='" +
                    data.variants[i].id +
                    "' data-regular-price='" + price + "' data-variant-sku='" + data.variants[i].sku + "'>" +
                    data.variants[i].title +
                    "" +
                    bestseller + " | " + priceString +
                    "</option>";
            }
            $(_this).find(".lm-cart-size select").html(html);            
            MAIN_RefreshPrice();
        });
    });

}

function selectFirstCartImage() {
    try {

        $(".lm-cart-slider").slick("slickGoTo", 0);

    } catch (e) {}
}

function initCartImages() {
    try {

        $(".lm-cart-slider").each(function(key, item) {
            var id = $(this).attr("id");
            $("#" + id).slick({
                prevArrow: "",
                nextArrow: "",
                infinite: true,
                lazyLoad: "ondemand",
                dots: true,
                autoplay: true,
                autoplaySpeed: 5500,
                cssEase: "ease-in-out",
                pauseOnHover: false,
                pauseOnFocus: false,
                prevArrow: "<a href='#' class='previos'><i class='fas fa-chevron-left'></i></a>",
                nextArrow: "<a href='#' class='next'><i class='fas fa-chevron-right'></i></a>",
            });
        });
        /*$(document).on("click", ".lm-cart-slider", function() {
            $(this).slick("slickNext");
        });*/
    } catch (e) {}
}

$(window).on("load", function() {
    initCartImages();
});
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

$(document).ready(function() {
    //Change item amount
    $(document).on("change", ".lm-cart-amount select", function() {
        var lineIndex = $(this).data("line-index");
        var quantity = $(this).val();
        quantity = quantity.replace(" (Entfernen)", "");
        var lineItem = $('.lm-cart-item[data-line-index="' + lineIndex + '"]');
        lineItem.find(".lm-item-loading").addClass("active");

        $.get(
            "/cart/change?line=" + (lineIndex + 1) + "&quantity=" + quantity,
            function(data) {
                if (quantity == 0) {
                    lineItem.slideUp(300, function() {
                        lineItem.find(".lm-item-loading").removeClass("active");
                        theme.cart.getCart().then(updateAnnouncementBar);   
                         $('body').trigger('added.ajaxProduct');
                    });
                } else {
                    lineItem.find(".lm-item-loading").removeClass("active");
                    theme.cart.getCart().then(updateAnnouncementBar);  
                     $('body').trigger('added.ajaxProduct');
                }
            }
        );
    });

    //Remove item
    $(document).on("click", ".lm-cart-remove", function() {
        var lineIndex = parseInt($(this).data("line-index"));
        var lineItem = $('.lm-cart-item[data-line-index="' + lineIndex + '"]');
        lineItem.find(".lm-item-loading").addClass("active");

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                //id: parseFloat(variantId),
                line: lineIndex + 1,
                quantity: 0,
            },
        }).then((data) => {
            lineItem.fadeOut(300, function() {
                theme.cart.getCart().then(updateAnnouncementBar);   
                $('body').trigger('added.ajaxProduct');
            });
        });
    });

    //Change canvas size
    $(document).on("change", ".lm-cart-size select", function() {
        var _this = this;
        var lineIndex = $(this).data("line-index");
        var lineItem = $('.lm-cart-item[data-line-index="' + lineIndex + '"]');
        lineItem.find(".lm-item-loading").addClass("active");
      
        var productType = lineItem.data("product-type");
        var selectedVariantID = $(_this).find(":selected").val();
        var selectedVariantSKU = $(_this).find(":selected").data("variant-sku");        

      
      
        $.getJSON("/cart.js", function(cart) {
            var properties = cart.items[lineIndex].properties; 
            if(properties.hasOwnProperty("_edit-url")) {
              var editURLString = properties["_edit-url"];
              var editURL = new URL(editURLString);
              editURL.searchParams.set("variant", selectedVariantID);            
              properties["_edit-url"] = editURL.toString();
            }
            
            if(productType == 'Grußkarte' && properties.hasOwnProperty("_lm-customizer0")) {
              properties['_edit-url'] = properties['_edit-url'].split('motiv=')[0] + "motiv=" + selectedVariantSKU.toLowerCase() + "&" + properties['_edit-url'].split('motiv=')[1].split('&')[1];
      
              properties['_lm-customizer0'] = properties['_lm-customizer0'].split('motiv=')[0] + "motiv=" + selectedVariantSKU.toLowerCase() + "&" + properties['_lm-customizer0'].split('motiv=')[1].split('&')[1];
            }           
            
            var quantity = cart.items[lineIndex].quantity;
            //Delete old product
              $.ajax({
                  type: 'POST',
                  url: "/cart/change.js",
                  data: JSON.stringify({
                      'line': parseInt(lineIndex + 1),
                      'quantity': 0
                  }),
                  dataType: 'json',
                  contentType: 'application/json',
                  success: async function(data) {
                    await sleep(1000);
                      $.ajax({
                          type: 'POST',
                          url: "/cart/add.js",
                          data: JSON.stringify({
                            'items': [{
                              'id': parseInt(selectedVariantID),
                              'quantity': quantity,
                              'properties': properties
                              }]
                          }),
                          dataType: 'json',
                          contentType: 'application/json',
                          success: function(data) {
                             theme.cart.getCart().then(updateAnnouncementBar); 
                            $('body').trigger('added.ajaxProduct');
                          lineItem.find(".lm-item-loading").removeClass("active");
                          },
                          error: function(data) {
                              console.log(data);
                          },
                      });
              
                  },
                  error: function(data) {
                      console.log(data);
                  },
              });
        });
    });

    //Toggle personalization details
    $(document).on("click", ".lm-cart-personalisierung-toggle", function() {
        var body = $(this).next(".lm-cart-personlisierung");
        var text = $(this).children("span");
        var icon = $(this).children("i");
        var active = body.hasClass("active");
        if (active) {
            body.removeClass("active");
            text.text("Personalisierung öffnen");
            icon.removeClass("fa-chevron-up").addClass("fa-chevron-down");
            body.slideUp(250);
        } else {
            body.addClass("active");
            text.text("Personalisierung schließen");
            icon.removeClass("fa-chevron-down").addClass("fa-chevron-up");
            body.slideDown(250);
        }
    });
    $(document).on("click", ".drawer__scrollable.cart-empty", function() {
        $(".drawer__close-button").trigger("click");
    });

    $(document).on('click', '.cart__checkout, .lm-go-checkout', function () {
        var _this = this;
        $(_this).addClass('btn--loading');
        setTimeout(function() {
          $(_this).removeClass('btn--loading');
        }, 5 * 1000);
    });


    //Photoswipe
    $(document).on("click", ".lm-cart-slider-image", function() {
        var index = parseInt($(this).attr('data-slick-index'));

        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = [];
        $(this).parent().children('.lm-cart-slider-image').each(function() {
            var item = {
                src: $(this).data('photoswipe-src'),
                w: 1024,
                h: 850,
                initialZoomLevel: 0.1,
            };

            items.push(item);
        });
        if(items.length > 1) {
          items = items.slice(1); //remove first element
          items.pop(); //remove last element 
        }
        
        var options = {
            allowPanToNext: false,
            captionEl: false,
            closeOnScroll: false,
            counterEl: false,
            history: false,
            index: index,
            pinchToClose: false,
            preloaderEl: false,
            scaleMode: 'zoom',
            shareEl: false,
            tapToToggleControls: false,
            secondaryZoomLevel: 3,
            maxZoomLevel: 5,
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      
        gallery.init();
    });
});